import { z } from "zod/v4";

export const LivestreamViewedActivityMetadata = z.object({
  viewedAt: z.iso.datetime(),
});
export type LivestreamViewedActivityMetadata = z.infer<typeof LivestreamViewedActivityMetadata>;

export const ClipViewedActivityMetadata = z.object({
  clipId: z.string(),
  viewedAt: z.iso.datetime(),
});
export type ClipViewedActivityMetadata = z.infer<typeof ClipViewedActivityMetadata>;

/**
 * A support user asked a camera to compile a full-quality clip over a time
 * range. Records the requested window and the `requestId` that identifies the
 * job, so an audit reader can tie the entry to the compilation it produced.
 */
export const ClipCompilationRequestedActivityMetadata = z.object({
  requestId: z.string(),
  rangeStart: z.iso.datetime(),
  rangeEnd: z.iso.datetime(),
  requestedAt: z.iso.datetime(),
});
export type ClipCompilationRequestedActivityMetadata = z.infer<typeof ClipCompilationRequestedActivityMetadata>;

/**
 * How a compilation was accessed: played in the watch view, or saved with the
 * download button.
 *
 * Records which action the user took, not whether they kept a copy — a viewer
 * holds the same signed URL a download uses, so `watch` does not rule out the
 * video having been saved some other way.
 */
export const ClipCompilationAccessMethod = z.enum(["watch", "download"]);
export type ClipCompilationAccessMethod = z.infer<typeof ClipCompilationAccessMethod>;

/**
 * Someone watched or downloaded a compilation. One kind rather than two
 * because both hand over the same full-quality video — an audit reader asking
 * who has had this footage needs both — with `via` saying which it was.
 */
export const ClipCompilationViewedActivityMetadata = z.object({
  requestId: z.string(),
  via: ClipCompilationAccessMethod,
  viewedAt: z.iso.datetime(),
});
export type ClipCompilationViewedActivityMetadata = z.infer<typeof ClipCompilationViewedActivityMetadata>;
